// How a chart reaches its host's notes endpoint (visual events, kind "notes").
//
// Every host serves the SAME routes — `POST …/visual-data/notes/{op}` with
// `{project, obj_name, layer, id?, date?, end?, label?, note?}` answering
// `{notes, can_add}` — but each has its own client (platform axios with the
// Run-as headers, the runtime's fetch). The host mounts ONE provider near its
// root; a chart with no provider shows notes read-only.

import { createContext, useContext, type ReactNode } from 'react'
import type { EventItem } from './model'

export type VisualNotesOp = 'list' | 'add' | 'update' | 'delete'

export interface VisualNotesAnswer {
  notes: EventItem[]
  can_add?: boolean
  admin?: boolean
}

export type VisualNotesTransport = (
  op: VisualNotesOp,
  body: Record<string, unknown>,
) => Promise<VisualNotesAnswer>

const Ctx = createContext<VisualNotesTransport | null>(null)

export function VisualEventNotesProvider({ value, children }: { value: VisualNotesTransport; children: ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>
}

export function useVisualNotesTransport(): VisualNotesTransport | null {
  return useContext(Ctx)
}
